export const REPORTS_NEW_SAVE_REPORTS_KEY_VALUE = 'REPORTS_NEW_SAVE_REPORTS_KEY_VALUE';
export const REPORTS_NEW_RESET_REPORTS_KEY_VALUE = 'REPORTS_NEW_RESET_REPORTS_KEY_VALUE';
